export default __webpack_public_path__ + "static/media/default_help.4a06f492.txt";